module.exports = __webpack_public_path__ + "static/Vroom-f8598502b43b63685043053936abbc33.jpg";